import { Box } from "@mui/joy";
import type { Dive } from "../../../../../api/followup/Followup.typed";
import DarkTypography from "../../../../common/DarkTypography";
import { textTokens } from "../../../../../styles/globalStyles";

const headerStyles = {
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "5% 17% 15% 8% 7% 9% 20%",
    gap: 1,
    padding: 1,
  },
  gridTypographyTitle: {
    color: textTokens.color.bodyOnLight,
    fontWeight: "bold",
    fontSize: "clamp(0.7rem, 2vw, 1rem)",
  },
  gridTypography: {
    color: textTokens.color.bodyOnLight,
    fontSize: "clamp(0.7rem, 2vw, 1rem)",
  },
  headerTypography: {
    color: textTokens.color.title,
    fontWeight: "bold",
    fontSize: "clamp(1rem, 3vw, 1.5rem)",
  },
};

type SummaryHeaderProps = {
  customerName: string;
  trainingTitle: string;
  dives: Dive[];
  isSmallScreen: boolean;
};

export default function SummaryHeader({
  customerName,
  trainingTitle,
  dives,
  isSmallScreen,
}: SummaryHeaderProps) {
  return (
    <Box sx={{ width: "100%" }}>
      <DarkTypography sx={headerStyles.headerTypography} mb={2}>
        {customerName} - {trainingTitle}
      </DarkTypography>
      <Box sx={headerStyles.gridContainer}>
        <DarkTypography sx={headerStyles.gridTypographyTitle}>N°</DarkTypography>
        <DarkTypography sx={headerStyles.gridTypographyTitle}>Date</DarkTypography>
        <DarkTypography sx={headerStyles.gridTypographyTitle}>Moniteur</DarkTypography>
        <DarkTypography sx={headerStyles.gridTypographyTitle}>Site</DarkTypography>
        <DarkTypography sx={headerStyles.gridTypographyTitle}>P(m)</DarkTypography>
        <DarkTypography sx={headerStyles.gridTypographyTitle}>T(min)</DarkTypography>
        <DarkTypography sx={headerStyles.gridTypographyTitle}>
          {isSmallScreen ? "Notes" : "Commentaires"}
        </DarkTypography>
      </Box>

      {dives.map((dive, idx) => (
        <Box
          key={idx}
          sx={{
            ...headerStyles.gridContainer,
            borderBottom: "1px solid #D8D8D8",
          }}
        >
          <DarkTypography sx={headerStyles.gridTypography}>{dive.Number}</DarkTypography>
          <DarkTypography sx={headerStyles.gridTypography}>
            {new Date(dive.Date).toLocaleDateString("fr-FR")}
          </DarkTypography>
          <DarkTypography sx={headerStyles.gridTypography}>{dive.Instructor}</DarkTypography>
          <DarkTypography sx={headerStyles.gridTypography}>{dive.DiveSite}</DarkTypography>
          <DarkTypography sx={headerStyles.gridTypography}>{dive.DiveDepth}</DarkTypography>
          <DarkTypography sx={headerStyles.gridTypography}>{dive.DiveTime}</DarkTypography>
          <DarkTypography sx={headerStyles.gridTypography}>{dive.Comment}</DarkTypography>
        </Box>
      ))}
    </Box>
  );
}
